import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import warning from "../../assets/logo/warning.png";
import React from "react";

export default function AlertRole({ isOpen, onClose }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Role Berbeda</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="column"
            px="4"
            width="full"
          >
            <img
              src={warning}
              alt="Logo"
              style={{
                borderRadius: "5px",
                maxWidth: "200px",
                maxHeight: "200px",
              }}
            />
            <Box textAlign="center" py="5">
              <Text fontWeight="700" fontSize="20">
                Role Tidak Bisa
              </Text>
              <Text fontWeight="400" fontSize="12">
                Mohon Maaf dengan Role anda tidak bisa melakukan checkout barang
                melebihi dari 1 barang, mohon kontak administrator
              </Text>
            </Box>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
